
import { useCostsActions } from "@contexts/costs";
import { useState } from "react";
import { BRAZILIAN_STATES } from "@utils/brazilianStates";

const INDEXER_TYPES = ['CUB', 'INCC'];

const emptyIndexer = { type: 'CUB', state: '', date: '', value: '' }

// indexer: opcional — quando informado, o formulário abre em modo de edição. Tipo/Estado/Mês
// formam a chave do registro em `baseCost` (junto — ver updateCost.js), então em edição eles
// ficam travados: só o Valor é editável. Trocar a chave é, na prática, criar outro registro.
const NewIndexer = ({ indexer, onSuccess }) => {
  const isEditing = !!indexer
  const [form, setForm] = useState(indexer ? { ...indexer } : emptyIndexer)
  const { updateIndexer } = useCostsActions();

  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSend = async (e) => {
    e.preventDefault()
    const result = await updateIndexer({ ...form, value: +form.value })
    if (result?.code === 200) {
      if (!isEditing) setForm(emptyIndexer)
      onSuccess?.({ ok: true, message: result.message })
    } else {
      onSuccess?.({ ok: false, message: result?.message || 'Não foi possível salvar o índice.' })
    }
  }

  const disabled = !form.type || !form.state || !form.date || form.value === ''

  return (
    <div className="backoffice-form-card">
      <h2>{isEditing ? 'Editar Índice' : 'Novo Índice'}</h2>
      <form className="new-building-container">
        <div>
          <label>Índice</label>
          <select name="type" value={form.type} onChange={handleInput} disabled={isEditing}>
            {INDEXER_TYPES.map(option => <option key={option} value={option}>{option}</option>)}
          </select>
        </div>
        <div>
          <label>Estado (UF)</label>
          <select name="state" value={form.state} onChange={handleInput} disabled={isEditing}>
            <option disabled value=''>Choose</option>
            {BRAZILIAN_STATES.map(({ uf, name }) => <option key={uf} value={uf}>{uf} — {name}</option>)}
          </select>
        </div>
        <div>
          <label>Mês</label>
          <input type="month" name="date" value={form.date} onChange={handleInput} disabled={isEditing} />
        </div>
        <div>
          <label>Valor</label>
          <input type="number" step="0.01" name="value" value={form.value} onChange={handleInput} />
        </div>

        <div className="edit-user-actions">
          <button disabled={disabled} className="button button-accent" onClick={handleSend}>
            {isEditing ? 'Salvar' : 'Enviar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewIndexer;
